import { render, staticRenderFns } from "./formCompany.vue?vue&type=template&id=db8701fe&scoped=true"
import script from "./formCompany.vue?vue&type=script&lang=js"
export * from "./formCompany.vue?vue&type=script&lang=js"
import style0 from "./formCompany.vue?vue&type=style&index=0&id=db8701fe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8701fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db8701fe')) {
      api.createRecord('db8701fe', component.options)
    } else {
      api.reload('db8701fe', component.options)
    }
    module.hot.accept("./formCompany.vue?vue&type=template&id=db8701fe&scoped=true", function () {
      api.rerender('db8701fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/companies/components/form/steps/formCompany.vue"
export default component.exports